WiseMetering.Views.WaterbeepIntegrationDetails = Backbone.Marionette.ItemView.extend({
    className: 'dashboard full-height',
    template: 'templates/integrations/waterbeep/show/details',

    modelEvents: {
        'change': 'render'
    },

    events: {
        'click #edit_attributes': 'editAttributes'
    },

    editAttributes: function(event) {
        event.stopPropagation();
        new WiseMetering.Views.EditWaterbeepIntegration({ model: this.model });
    },

    serializeData: function() {
        return {
            ...this.model.toJSON(),
            site: this.model.site(),
            integrationIndicators: this.model.integrationIndicators()
        };
    }
});
